import { render, staticRenderFns } from "./client_n.vue?vue&type=template&id=b87c28e2"
import script from "./client_n.vue?vue&type=script&lang=js"
export * from "./client_n.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports